import { isAxiosError, type AxiosError } from 'axios';

/** Shown whenever an API returns 403 module access denied. */
export const MODULE_ACCESS_DENIED_USER_MESSAGE =
  'No access to this module. Contact your admin.';

/**
 * True when the backend ModuleAccess middleware rejected the request:
 * `{ "error": "module access denied", "module": "..." }` with status 403.
 */
export function isModuleAccessDeniedError(error: unknown): boolean {
  if (!isAxiosError(error) || error.response?.status !== 403) return false;
  const data = error.response.data;
  if (typeof data === 'string') {
    return /module access denied/i.test(data);
  }
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    const msg = (data as Record<string, unknown>).error;
    return typeof msg === 'string' && /module access denied/i.test(msg.trim());
  }
  return false;
}

/** Rewrite axios error so page UIs / toasts that read `.message` or `data.error` show the friendly text. */
export function applyModuleAccessDeniedMessage(error: AxiosError): void {
  error.message = MODULE_ACCESS_DENIED_USER_MESSAGE;
  const data = error.response?.data;
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    (data as Record<string, unknown>).error = MODULE_ACCESS_DENIED_USER_MESSAGE;
  }
}
